import {
  LOG_ACTION,
  LOG_CODE,
  LOG_TRANSCRIPTION,
} from "@/helpers/variables/logs";

import {
  ddiTags,
  editableCompanyTags,
  userEditableTags,
} from "@/helpers/variables/tags";
import { historyLogModuleName } from "@/helpers/variables/translateString";
import { i18n } from "@/plugins/vue-i18n";

export function getUpdatedDescription(description) {
  let action = "";
  if (description.includes("CREATE")) {
    action = "CREATE";
  } else if (description.includes("DELETE")) {
    action = "DELETE";
  }

  return description.substring(description.indexOf(action), description.length);
}

export function translateDescription(log) {
  const { description } = log;
  let updatedDescription = getUpdatedDescription(description);
  const words = updatedDescription.split(" ");
  let translatedDescription = "";
  for (let i = 0; i < words.length; i++) {
    let word = words[i];
    if (!word) {
      word = "NOT_FOUND";
    }
    let translatedWord = getTranslation(word);
    translatedDescription += translatedWord;
  }
  return translatedDescription;
}

export function getTranslation(word) {
  return Object.keys(LOG_TRANSCRIPTION).includes(word)
    ? LOG_TRANSCRIPTION[word]
    : ` <span class="font-weight-medium">${word}</span>`;
}

export function getActionTranslation(action) {
  return LOG_ACTION[action];
}

export function getEmailLogsDescription(log) {
  let description = LOG_CODE[log.context].description;
  let IMPACTED_EMAILS = [];
  let AUTHOR = log.author.email || "Usuário não encontrado";
  log.impacted_emails.forEach((email) => {
    IMPACTED_EMAILS.push(`\n${email}`);
  });
  description = description.replace("{AUTHOR}", `<b>${AUTHOR}</b>`);
  description = description.replace(
    "{IMPACTED_USERS}",
    `<b>${
      IMPACTED_EMAILS.length ? IMPACTED_EMAILS : "usuários não encontrados"
    }</b>`
  );
  return description;
}

export function getNewUsersEmailLogsDescription(log) {
  let description = LOG_CODE[log.context].description;
  let IMPACTED_EMAILS = [];
  log.object.users_applied.forEach((email) => {
    IMPACTED_EMAILS.push(`\n${email}`);
  });
  description = description.replace(
    "{IMPACTED_USERS}",
    `<b>${
      IMPACTED_EMAILS.length ? IMPACTED_EMAILS : "usuários não encontrados"
    }</b>`
  );
  return description;
}

export function getUserLogDescription(log) {
  const { context, object, author } = log;
  let description = LOG_CODE[context].description;
  description = description.replace("{AUTHOR}", `<b>${author.name}</b>`);
  description = description.replace("{USER}", `<b>${object.user?.email}</b>`);
  return description;
}

export function getOnboardingUserLogDescription(log) {
  const { context, object, author } = log;
  let description = LOG_CODE[context].description;
  description = description.replace("{AUTHOR}", `<b>${author.name}</b>`);
  description = description.replace(
    "{USER}",
    `<b>${object.user.primaryEmail}</b> pelo onboarding`
  );
  return description;
}

export function getVerifyPhoneLogDescription(log) {
  const { context, object, author } = log;
  let description = LOG_CODE[context].description;
  description = description.replace("{AUTHOR}", `<b>${author.name}</b>`);
  description = description.replace("{PHONE}", `<b>${object.phone}</b>`);
  return description;
}

export function getUserPermissioneLogDescription(log) {
  const { context, product, user_modified_email, object } = log;
  const descriptionKey =
    object.action === "ADD_USER_PERMISSION"
      ? "descriptionAdd"
      : "descriptionRemove";
  let description = LOG_CODE[context][descriptionKey];
  description = description.replace("{USER}", `<b>${user_modified_email}</b>`);
  description = description.replace(
    "{PRODUCT}",
    `<b>${historyLogModuleName[product]}</b>`
  );

  return description;
}

export function getEmailMigrationLogDescription(log) {
  return log.description;
}

export function getChangedTagValues(log) {
  const changes = [];
  const tagsChanged = log.object.changes ? Object.keys(log.object.changes) : "";
  if (!tagsChanged) return "Não encontrado";
  tagsChanged.forEach((key) => {
    const keyName =
      editableCompanyTags[key]?.keyName ||
      ddiTags[key]?.keyName ||
      userEditableTags[key]?.keyName;
    const newValue = log.object.changes[key].new_value;
    if (keyName && newValue) {
      changes.push(`${keyName}: ${newValue}`);
    }
  });

  return changes.join("\n");
}

export function getVacationLogsDescription(log) {
  let description = LOG_CODE[log.context].description;
  const AUTHOR = log.author?.email || "Usuário não encontrado";
  let selectedUsers = [];

  try {
    const object =
      typeof log.object === "string" ? JSON.parse(log.object) : log.object;
    selectedUsers = object?.selected_users || [];
  } catch (e) {
    console.warn(
      "Erro ao fazer parse de log.object em getVacationLogsDescription:",
      e
    );
  }

  const IMPACTED_USERS = selectedUsers.length
    ? selectedUsers.join(", ")
    : "usuários não encontrados";

  description = description.replace("{AUTHOR}", `<b>${AUTHOR}</b>`);
  description = description.replace(
    "{IMPACTED_USERS}",
    `<b>${IMPACTED_USERS}</b>`
  );

  return description;
}

export function getMigrationLogsDescription(log) {
  let object = {};

  try {
    object =
      typeof log.object === "string" ? JSON.parse(log.object) : log.object;
  } catch (error) {
    console.error("getMigrationLogsDescription()", error);
  }
  const action =
    object.email_to_group == "interrupted"
      ? i18n.t("reports.description.interrupted")
      : i18n.t("reports.description.canceled");

  const source_email =
    object.migrations_in_queue?.email_to_group?.user_email || "";

  const target_email = object.migrations_in_queue?.email_to_group?.group || "";

  const created_date = new Date(object.created_at).toLocaleDateString(
    localStorage?.getItem?.("lang") || window?.navigator?.language || "pt-BR",
    {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }
  );

  return i18n.t("reports.migration.description", {
    action,
    source_email,
    target_email,
    created_date,
  });
}
